import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { responsiveFontSize } from '@presentation/styles';

export const Section = styled.div<{ centerChildren?: boolean }>`
  margin-top: 25px;
  ${(props) => props.centerChildren && 'text-align: center;'}
`;

export const title = (props: any) => css`
  font-family: ${props.theme.font.alternate};
  font-weight: 600;
  color: ${props.theme.color.blue.default};
  ${responsiveFontSize(36, 4)}
  margin-bottom: 15px;
`;

export const H1SectionTitle = styled.h1`
  ${title}
`;

export const SectionTitle = styled.h2`
  ${title}
`;

export const SectionSubtitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 15px;
`;

export const SectionText = styled.div`
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
  white-space: pre-wrap;
`;
